const initialState = () => ({
    day: false,
    selectTime: false,
    dayInfo: false,
    month: false,
    year: false,
    primeTime: false,
    name: '',
    times: []
})

const mutations = {
    setDay(state, { day }) {
        state.day = day
    },
    setMonth(state, { month }) {
        state.month = month
    },
    setYear(state, { year }) {
        state.year = year
    },
    setName(state, { name }) {
        state.name = name
    },
    setTimes(state, { times }) {
        state.times = times
    },
    setDayInfo(state, {  info }) {
        state.dayInfo = info
    },
    setSelectTime(state, { time }) {
        state.selectTime = time
    },
    setPrimeTime(state, { status }) {
        state.primeTime = status
    },
    resetState(state) {
        const initial = initialState()
        Object.keys(initial).forEach(key => { state[key] = initial[key] })
    }
}

const actions = {
    async setDay({ commit }, { day }) {
        commit('setDay', { day })
    },
    async setMonth({ commit }, { month }) {
        commit('setMonth', { month })
    },
    async setYear({ commit }, { year }) {
      commit('setYear', { year })
    },
    async setName({ commit }, { name }) {
        commit('setName', { name })
    },
    async generateName({ commit, state }) {
        let name;

        if(state.month === 1) {
            name = 'Января'
        } else if(state.month === 2) {
            name = 'Февраля'
        } else if(state.month === 3) {
            name = 'Марта'
        } else if(state.month === 4) {
            name = 'Апреля'
        } else if(state.month === 5) {
            name = 'Мая'
        } else if(state.month === 6) {
            name = 'Июня'
        } else if(state.month === 7) {
            name = 'Июля'
        } else if(state.month === 8) {
            name = 'Августа'
        } else if(state.month === 9) {
            name = 'Сентября'
        } else if(state.month === 10) {
            name = 'Октября'
        } else if(state.month === 11) {
            name = 'Ноября'
        } else if(state.month === 12) {
            name = 'Декабря'
        }

        commit('setName', {
            name: name
        })
    },
    async setTimes({ commit }, { times }) {
        commit('setTimes', { times })
    },
    async setDayInfo({ commit }, { info }) {
        commit('setDayInfo', { info })
    },
    async setSelectTime({ commit }, { time }) {
        commit('setSelectTime', { time })
    },
    async setPrimeTime({ commit }, { status }) {
        commit('setPrimeTime', { status })
    },
    resetState({ commit }) {
        commit('resetState')
    }
}


const getters = {
    day: state => state.day,
    selectTime: state => state.selectTime,
    month: state => state.month,
    year: state => state.year,
    name: state => state.name,
    times: state => state.times,
    dayInfo: state => state.dayInfo,
    primeTime: state => state.primeTime
}

export default {
    namespaced: true,
    state: initialState,
    getters,
    mutations,
    actions
};